import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { institutionTypeOptions } from '@/module/Nomen/InstitutionType/model/InstitutionTypeModel';

import { AsyncMultiSelectControl, AsyncSelectControlProps } from '@/core/components';

type InstitutionTypeMultiSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function InstitutionTypeMultiSelectControl<T extends FieldValues>(
  props: InstitutionTypeMultiSelectControlProps<T>,
) {
  const { data, isLoading, isError } = useQuery(institutionTypeOptions.getAll());

  return (
    <AsyncMultiSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
